var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cardStyle),attrs:{"id":"featureInfoContainerRoot"}},[_vm._t("default",null,{"id":"container"}),_c('OpenIcon',{style:(_vm.iconPosition),attrs:{"color":_vm.plusColor,"id":"icon"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }